var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewTable(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "20-view-table"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.19995 4.49995C1.19995 2.67741 2.67741 1.19995 4.49995 1.19995H19.5C21.3225 1.19995 22.7999 2.67741 22.7999 4.49995V19.5C22.7999 21.3225 21.3225 22.7999 19.5 22.7999H4.49995C2.67741 22.7999 1.19995 21.3225 1.19995 19.5V4.49995ZM2.99995 8.99995V19.5C2.99995 20.3284 3.67152 21 4.49995 21H7.19995V8.99995H2.99995ZM7.19995 7.19995H2.99995V4.49995C2.99995 3.67152 3.67152 2.99995 4.49995 2.99995H7.19995V7.19995ZM8.99995 8.99995V21H19.5C20.3284 21 21 20.3284 21 19.5V8.99995H8.99995ZM21 7.19995H8.99995V2.99995H19.5C20.3284 2.99995 21 3.67152 21 4.49995V7.19995Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewTable);
export default __webpack_public_path__ + "static/media/view_table.d1bffcf57185f032c8dbd864860ea286.svg";
export { ForwardRef as ReactComponent };